module.exports = __webpack_public_path__ + "img/ama_short@2x.d25a05e8.png";